import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { of } from 'rxjs';

const hasAllowedPuesto = (allowedPuestos: string[]): boolean => {
    if (!allowedPuestos?.length) {
        return true;
    }

    const userPuestos = AuthUtils.getPuestosList();
    if (!Array.isArray(userPuestos) || !userPuestos.length) {
        return false;
    }

    const normalizedUserPuestos = userPuestos.map((puesto) => String(puesto).toUpperCase());
    return allowedPuestos.some((puesto) => normalizedUserPuestos.includes(String(puesto).toUpperCase()));
};

export const PuestosGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const allowedPuestos = Array.isArray(route.data?.['puestos']) ? route.data['puestos'] : [];

    if (hasAllowedPuesto(allowedPuestos)) {
        return of(true);
    }

    return of(router.parseUrl('/404-not-found'));
};

export const PuestosMatchGuard: CanMatchFn = (route) => {
    const router: Router = inject(Router);
    const allowedPuestos = Array.isArray(route.data?.['puestos']) ? route.data['puestos'] : [];

    if (hasAllowedPuesto(allowedPuestos)) {
        return of(true);
    }

    return of(router.parseUrl('/404-not-found'));
};
